import { Spacing } from '@kezios/design-system';
import { Container, ContainerProps } from '@mantine/core';

export type SectionLayoutProps = {
  children: React.ReactNode;
} & ContainerProps;

export const SectionLayout = ({ children, ...props }: SectionLayoutProps) => {
  return (
    <Container {...props} size={1280} px={Spacing.s4} style={{ width: '100%' }}>
      {children}
    </Container>
  );
};
